import { Component, Input, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppRedirectService } from 'src/app/services/app-redirect.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-race-share-success-handling',
  templateUrl: './race-share-success-handling.component.html',
  styleUrls: ['./race-share-success-handling.component.scss']
})
export class RaceShareSuccessHandlingComponent implements AfterViewInit {

  translationData: any[] = [];
  @Input() error_header: any;
  @Input() error_sub_heading_1: any;
  error_sub_heading_2: any;
  showSpinner$!: Observable<boolean>;
  hasBanner: boolean = false;

  @Input() source: string = ''

  constructor(private readonly translationService: TranslationService, 
    private readonly _router: Router,
    private readonly appRedirectService: AppRedirectService) { }

  

  ngAfterViewInit() {
    setTimeout(() => {
      this.hasBanner = this.appRedirectService.checkBannerPresence();
    });
  }

  triggerGoToMyStories() {
    if (this.source === 'APP_STORE_REDIRECT') {
      this._router.navigate(['/stories']);
      return;
    }
    this.showSpinner$ = this.appRedirectService.showSpinner$;
    setTimeout(() => {
      this.appRedirectService.closeSpinner();
    }, 3000);
    this.appRedirectService.triggerGoToApp();
  }


}
